/* ========================================
   BK-MEDIA CUSTOM JAVASCRIPT
   ======================================== */

/* ========================================
   CART DRAWER RECOMMENDED PRODUCTS - ISOLATED FROM APP WIDGET
   ======================================== */

document.addEventListener('submit', function(event) {
  const form = event.target;
  const formId = form.getAttribute && form.getAttribute('id');
  if (form.tagName !== 'FORM' || !formId || formId.indexOf('complementary-product-') !== 0) return;
  if (!form.closest || !form.closest('cart-drawer')) return;

  event.preventDefault();
  event.stopPropagation();
  event.stopImmediatePropagation();

  const submitBtn = form.querySelector('button[type="submit"], [type="submit"]');
  if (submitBtn) {
    submitBtn.setAttribute('aria-busy', 'true');
    submitBtn.disabled = true;
  }

  (async function() {
    try {
      const variantId = form.querySelector('[name="id"]')?.value;
      const quantity = parseInt(form.querySelector('[name="quantity"]')?.value || '1', 10);
      const properties = {};
      form.querySelectorAll('input[name^="properties["]').forEach(function(input) {
        if (input.name && input.value) {
          const match = input.name.match(/properties\[([^\]]+)\]/);
          if (match) properties[match[1]] = input.value;
        }
      });

      let sectionsToBundle = ['variant-added'];
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
      const cartDrawerEl = document.getElementById('cart-drawer');
      const sectionId = cartDrawerEl?.getAttribute('data-section-id') || 'cart-drawer';
      if (sectionsToBundle.indexOf(sectionId) === -1) sectionsToBundle.push(sectionId);

      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: quantity, properties: properties }],
          sections: sectionsToBundle.join(','),
          sections_url: root + 'variants/' + variantId
        })
      });

      const responseJson = await response.json();

      if (response.ok) {
        const cartRes = await fetch(root + 'cart.js');
        const cartContent = await cartRes.json();
        cartContent.sections = responseJson.sections || {};
        form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: responseJson.items || [responseJson], cart: cartContent } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cartContent } }));
      } else {
        form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: responseJson.description } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    } catch (e) {
      console.error('Cart drawer recommend add failed:', e);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh'));
    } finally {
      if (submitBtn) {
        submitBtn.removeAttribute('aria-busy');
        submitBtn.disabled = false;
      }
    }
  })();
}, true);

/* ========================================
   QUANTITY DISCOUNT BLOCK FUNCTIONALITY
   ======================================== */
document.addEventListener('DOMContentLoaded', function() {
  // Initialize all quantity discount blocks
  const quantityDiscountBlocks = document.querySelectorAll('.bk-media-quantity-discount');
  
  quantityDiscountBlocks.forEach(function(block) {
    initializeQuantityDiscount(block);
  });
});

function initializeQuantityDiscount(block) {
  const options = block.querySelectorAll('.bk-media-quantity-discount__option');
  const priceAmount = block.querySelector('.bk-media-quantity-discount__price-amount');
  const priceBadge = block.querySelector('.bk-media-quantity-discount__price-badge');
  const quantityInput = block.querySelector('.bk-media-quantity-discount__quantity-input');
  const savingsDisplay = block.querySelector('.bk-media-quantity-discount__savings');
  const savingsAmount = block.querySelector('.bk-media-quantity-discount__savings-amount');
  
  if (!priceAmount || !options.length) return;
  
  const basePrice = parseInt(priceAmount.dataset.price);
  
  function updatePricing(selectedOption) {
    const quantity = parseInt(selectedOption.dataset.quantity);
    const discount = parseInt(selectedOption.dataset.discount);
    
    // Calculate total price with discount
    const totalPrice = Math.round(basePrice * quantity * (1 - discount / 100));
    const pricePerBox = Math.round(totalPrice / quantity);
    const savings = Math.round(basePrice * quantity * (discount / 100));
    
    // Update price display
    const formattedTotalPrice = (totalPrice / 100).toFixed(2).replace('.', ',');
    const formattedPricePerBox = (pricePerBox / 100).toFixed(2).replace('.', ',');
    
    priceAmount.textContent = '€' + formattedTotalPrice;
    priceBadge.textContent = 'nur €' + formattedPricePerBox + '/ Box';
    
    // Update quantity input
    if (quantityInput) {
      quantityInput.value = quantity;
      
      // Trigger change event to update form
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    
    // Show/hide savings
    if (savingsDisplay && savingsAmount) {
      if (discount > 0) {
        const formattedSavings = (savings / 100).toFixed(2).replace('.', ',');
        savingsAmount.textContent = '€' + formattedSavings;
        savingsDisplay.style.display = 'block';
      } else {
        savingsDisplay.style.display = 'none';
      }
    }
    
    // Update selected state
    options.forEach(function(option) {
      option.classList.remove('selected');
      option.dataset.selected = 'false';
    });
    selectedOption.classList.add('selected');
    selectedOption.dataset.selected = 'true';
  }

  // Add click handlers
  options.forEach(function(option) {
    option.addEventListener('click', function() {
      updatePricing(this);
    });
  });

  // Initialize with first option
  const firstOption = options[0];
  if (firstOption) {
    updatePricing(firstOption);
  }
}

// Reinitialize quantity discount blocks when sections are loaded
document.addEventListener('shopify:section:load', function(event) {
  const quantityDiscountBlocks = event.target.querySelectorAll('.bk-media-quantity-discount');
  quantityDiscountBlocks.forEach(function(block) {
    initializeQuantityDiscount(block);
  });
});

function initAudioPlayers() {
  const audioPlayers = document.querySelectorAll('.bk-media-audio-player');
  
  audioPlayers.forEach(player => {
    const playBtn = player.querySelector('.bk-media-audio-player__play-btn');
    const audio = player.querySelector('.bk-media-audio-player__audio');
    const playIcon = player.querySelector('.bk-media-audio-player__play-icon');
    const waveformBars = player.querySelectorAll('.bk-media-audio-player__waveform-bar');
    const waveform = player.querySelector('.bk-media-audio-player__waveform');
    
    if (!playBtn || !audio || !playIcon) return;
    
    function hexToRgb(hex) {
      if (!hex) return null;
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
      } : null;
    }
    
    const waveformColor = (getComputedStyle(player).getPropertyValue('--waveform-color') || '#811E3C').trim();
    const waveformColorRgb = hexToRgb(waveformColor);
    const defaultInactiveColor = waveformColorRgb ? `rgba(${waveformColorRgb.r}, ${waveformColorRgb.g}, ${waveformColorRgb.b}, 0.3)` : 'rgba(129, 30, 60, 0.3)';
    const defaultActiveColor = waveformColor;
    
    waveformBars.forEach(bar => {
      const height = bar.getAttribute('data-height');
      const topHeight = height / 2;
      const bottomHeight = height / 2;
      
      bar.style.position = 'relative';
      bar.style.height = `${height}%`;
      bar.style.background = 'transparent';
      
      const topPart = document.createElement('div');
      topPart.style.position = 'absolute';
      topPart.style.top = '50%';
      topPart.style.left = '0';
      topPart.style.width = '100%';
      topPart.style.height = `${topHeight}%`;
      topPart.style.background = defaultInactiveColor;
      topPart.style.transform = 'translateY(-100%)';
      topPart.className = 'waveform-bar-top';
      
      const bottomPart = document.createElement('div');
      bottomPart.style.position = 'absolute';
      bottomPart.style.top = '50%';
      bottomPart.style.left = '0';
      bottomPart.style.width = '100%';
      bottomPart.style.height = `${bottomHeight}%`;
      bottomPart.style.background = defaultInactiveColor;
      bottomPart.style.transform = 'translateY(0)';
      bottomPart.className = 'waveform-bar-bottom';
      
      bar.appendChild(topPart);
      bar.appendChild(bottomPart);
    });
    
    function stopAllOtherPlayers() {
      audioPlayers.forEach(otherPlayer => {
        if (otherPlayer !== player) {
          const otherAudio = otherPlayer.querySelector('.bk-media-audio-player__audio');
          const otherPlayBtn = otherPlayer.querySelector('.bk-media-audio-player__play-btn');
          const otherPlayIcon = otherPlayer.querySelector('.bk-media-audio-player__play-icon');
          
          if (otherAudio && otherPlayBtn && otherPlayIcon) {
            otherAudio.pause();
            otherAudio.currentTime = 0;
            otherPlayer.classList.remove('playing');
            otherPlayBtn.classList.remove('playing');
            otherPlayIcon.innerHTML = '<path d="M8 5V19L19 12L8 5Z" fill="currentColor"/>';
          }
        }
      });
    }
    
    playBtn.addEventListener('click', function() {
      if (audio.paused) {
        stopAllOtherPlayers();
        
        audio.play().then(() => {
          player.classList.add('playing');
          playBtn.classList.add('playing');
          playIcon.innerHTML = '<path d="M6 4H10V20H6V4ZM14 4H18V20H14V4Z" fill="currentColor"/>';
        }).catch(error => {
          console.error('Error playing audio:', error);
        });
      } else {
        audio.pause();
        player.classList.remove('playing');
        playBtn.classList.remove('playing');
        playIcon.innerHTML = '<path d="M8 5V19L19 12L8 5Z" fill="currentColor"/>';
      }
    });
    
    function updateProgress() {
      if (audio.duration && audio.readyState >= 1) {
        const progress = (audio.currentTime / audio.duration) * 100;
        const barsCount = waveformBars.length;
        const playedBarsCount = Math.floor((progress / 100) * barsCount);
        
        waveformBars.forEach((bar, index) => {
          const topPart = bar.querySelector('.waveform-bar-top');
          const bottomPart = bar.querySelector('.waveform-bar-bottom');
          
          const barProgress = ((progress / 100) * barsCount) - index;
          const isActive = index < playedBarsCount;
          const isPartiallyActive = index === playedBarsCount && barProgress > 0;
          
          if (isActive) {
            if (topPart) topPart.style.background = defaultActiveColor;
            if (bottomPart) bottomPart.style.background = defaultActiveColor;
            bar.classList.add('played');
          } else if (isPartiallyActive) {
            const opacity = Math.max(0.3, barProgress);
            if (waveformColorRgb) {
              if (topPart) topPart.style.background = `rgba(${waveformColorRgb.r}, ${waveformColorRgb.g}, ${waveformColorRgb.b}, ${opacity})`;
              if (bottomPart) bottomPart.style.background = `rgba(${waveformColorRgb.r}, ${waveformColorRgb.g}, ${waveformColorRgb.b}, ${opacity})`;
            } else {
              if (topPart) topPart.style.background = defaultInactiveColor;
              if (bottomPart) bottomPart.style.background = defaultInactiveColor;
            }
            bar.classList.add('played');
          } else {
            if (topPart) topPart.style.background = defaultInactiveColor;
            if (bottomPart) bottomPart.style.background = defaultInactiveColor;
            bar.classList.remove('played');
          }
        });
      }
    }
    
    audio.addEventListener('timeupdate', updateProgress);
    
    audio.addEventListener('ended', function() {
      player.classList.remove('playing');
      playBtn.classList.remove('playing');
      playIcon.innerHTML = '<path d="M8 5V19L19 12L8 5Z" fill="currentColor"/>';
      
      waveformBars.forEach(bar => {
        const topPart = bar.querySelector('.waveform-bar-top');
        const bottomPart = bar.querySelector('.waveform-bar-bottom');
        if (topPart) topPart.style.background = defaultInactiveColor;
        if (bottomPart) bottomPart.style.background = defaultInactiveColor;
        bar.classList.remove('played');
      });
    });
    
    audio.addEventListener('error', function() {
      console.error('Audio playback error for:', audio.src);
      player.classList.remove('playing');
      playBtn.classList.remove('playing');
      playIcon.innerHTML = '<path d="M8 5V19L19 12L8 5Z" fill="currentColor"/>';
      
      waveformBars.forEach(bar => {
        const topPart = bar.querySelector('.waveform-bar-top');
        const bottomPart = bar.querySelector('.waveform-bar-bottom');
        if (topPart) topPart.style.background = defaultInactiveColor;
        if (bottomPart) bottomPart.style.background = defaultInactiveColor;
        bar.classList.remove('played');
      });
    });
    
    audio.addEventListener('pause', function() {
      if (audio.currentTime === 0) {
        waveformBars.forEach(bar => {
          const topPart = bar.querySelector('.waveform-bar-top');
          const bottomPart = bar.querySelector('.waveform-bar-bottom');
          if (topPart) topPart.style.background = defaultInactiveColor;
          if (bottomPart) bottomPart.style.background = defaultInactiveColor;
          bar.classList.remove('played');
        });
      }
    });
    
    if (waveform) {
      waveform.addEventListener('click', function(e) {
        if (audio.duration && audio.readyState >= 1) {
          const rect = waveform.getBoundingClientRect();
          const clickX = e.clientX - rect.left;
          const boundedX = Math.max(0, Math.min(clickX, rect.width));
          const clickPercentage = boundedX / rect.width;
          const newTime = clickPercentage * audio.duration;
          
          waveform.classList.add('seeking');
          waveform.style.setProperty('--seek-position', `${clickPercentage * 100}%`);
          audio.currentTime = Math.max(0, Math.min(newTime, audio.duration));
          updateProgress();
          
          setTimeout(() => {
            waveform.classList.remove('seeking');
          }, 300);
          
          requestAnimationFrame(() => {
            updateProgress();
          });
        }
      });
      
      waveform.addEventListener('touchstart', function(e) {
        e.preventDefault();
      });
      
      waveform.addEventListener('touchend', function(e) {
        e.preventDefault();
        if (audio.duration && audio.readyState >= 1) {
          const rect = waveform.getBoundingClientRect();
          const touch = e.changedTouches[0];
          const clickX = touch.clientX - rect.left;
          const boundedX = Math.max(0, Math.min(clickX, rect.width));
          const clickPercentage = boundedX / rect.width;
          const newTime = clickPercentage * audio.duration;
          
          waveform.classList.add('seeking');
          waveform.style.setProperty('--seek-position', `${clickPercentage * 100}%`);
          audio.currentTime = Math.max(0, Math.min(newTime, audio.duration));
          updateProgress();
          
          setTimeout(() => {
            waveform.classList.remove('seeking');
          }, 300);
          
          requestAnimationFrame(() => {
            updateProgress();
          });
        }
      });
      
      waveform.style.cursor = 'pointer';
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initAudioPlayers();
});

document.addEventListener('shopify:section:load', function() {
  initAudioPlayers();
});